// extracted by mini-css-extract-plugin
export default {"QuizResultContainer":"quizResultContainer_QuizResultContainer__dVFke","title":"quizResultContainer_title__rSpcm","content":"quizResultContainer_content__otJ+k"};